<template lang="pug">
.outstanding-list()
  .sticky-top.bg-white
    .d-flex.align-items-center.justify-content-between.px-3.pt-3
      .d-flex
        .text-large
          template(v-if="onlyPastDue") รายการครบกำหนดชำระ
          template(v-else) รายการค้างชำระ
        //- LoadingIndicator.ml-2(v-if='isLoading')
      //- CustomDatePicker(v-model='filterDate')
      //- แสดงผลทั้งหมดไปเลย
    .d-flex.px-3.pb-3
      .text-normal(style="opacity: 0.5;") ทั้งหมด {{sum | currency}} บาท
    hr.m-0
  //- .pt-2.pb-2.px-3
  //-   CustomTable(
  //-     :columns='tableCols'
  //-     :data='filteredTableData'
  //-   )
  LoadedContentWrapper.flex-fill(
    :isLoading='isLoading'
    :data='tableData'
    @reload='loadData'
  )
    .py-2.px-3.flex-fill
      CustomTable(
        :columns='tableColumns'
        :data='filteredTableData'
        :showIndexes='true'
        :startIndex='pageFirstRowIndex'
        :showNotificationDots='true'
      )
        //- @itemClicked='showModal'

    .bg-white(
      :class=`{'sticky-bottom' : sticky === true}`
    )
      hr.m-0
      .px-4.py-3
        CustomPagination(
          v-model='currentPage'
          :total='totalPage'
          :compact='true'
        )
</template>

<script>
/* eslint-disable arrow-body-style */
export default {
  props: {
    customerId: {},

    sticky: {
      default: true,
    },

    onlyPastDue: {
      default: false,
    },
  },
  computed: {
    filteredTableData() {
      // if (this.tableData) {
      //   return this.tableData.filter((item) => {
      //     return (this.filterDate === '')
      // || (this.$dateUtils.isInRange(item.dueDate, this.filterDate));
      //   });
      // }
      // return [];
      return this.tableData;
    },
  },
  watch: {
    // tableData() {
    //   // this.$emit('finishLoading', {
    //   //   data: this.filteredTableData,
    //   //   count: this.filteredTableData.length,
    //   // });
    //   this.$emit('finishLoading', this.filteredTableData);
    // },

    // reload data
    filterDate: {
      handler() { this.currentPage = 1; this.loadData(); },
      deep: true,
    },
    filterSearch() { this.currentPage = 1; this.loadData(); },
    customerId() { this.currentPage = 1; this.loadData(); },
    currentPage() { this.loadData(); },
  },
  data() {
    return {
      filterDate: '',
      isLoading: false,

      tableData: [],
      tableColumns: {
        // no: {
        //   title: 'ลำดับ',
        //   align: 'center',
        // },
        dueDate: {
          title: 'วันที่ครบกำหนด',
          align: 'center',
          type: Date,
        },
        customerName: {
          title: 'ชื่อลูกค้า',
          align: 'left',
          computed: row => ((row.customer) ? row.customer.name : '-'),
        },
        total: {
          title: 'ยอดรวม',
          align: 'right',
          type: Number,
        },
        daysPastDue: {
          title: 'วันที่เกิน',
          align: 'right',
          computed: row => ((parseInt(row.daysPastDue, 10) < 0) ? 0 : row.daysPastDue),
          // computed: (row) => {
          //   const TODAY = this.$moment();
          //   const DUE_DATE = this.$moment(row.dueDate);
          //   return TODAY.diff(DUE_DATE, 'days');
          // },
        },
        sellDate: {
          title: 'วันที่ทำรายการ',
          align: 'center',
          type: Date,
        },
      },

      // pagination
      currentPage: 1,
      totalPage: 0,
      totalRows: 0,
      pageFirstRowIndex: 1,
      sum: 0,
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    async loadData() {
      this.isLoading = true;

      // const res = await this.$api.customer.history.unpaid(this.customer.id);
      // load data
      try {
        const res = await this.$api.billing.outstandings(
          this.customerId, // this.customer.id,
          this.currentPage,
          undefined, // this.filterSearch,
          undefined,
          this.onlyPastDue,
        );

        if (res.status === 200) {
          this.tableData = res.data.data;
          this.currentPage = res.data.current_page;
          this.totalPage = res.data.last_page;
          this.totalRows = res.data.total;
          this.pageFirstRowIndex = res.data.from;
          this.sum = res.data.sum;
          this.$emit('finishLoading', res.data);
        }
      } catch (e) {
        this.tableData = null;
        this.pageFirstRowIndex = 1;
      }

      this.isLoading = false;

      // this.isLoading = true;

      // const res = await this.$api.user.unpaidList();
      // if (res.status === 200) {
      //   this.tableData = res.data.data;
      //   this.$emit('finishLoading', this.filteredTableData);
      // }

      // this.isLoading = false;
    },
  },
};
</script>

<style lang="scss">
.filter-date {
  font-size: 20px;
}
</style>
